<template>
  <el-dialog title="新建文件夹" :visible.sync="visible" width="563px" :before-close="handleClose">
    <el-form ref="ruleForm" label-width="84px" :rules="rules" :model="ruleForm" class="ruleForm">
      <el-form-item label="路径：" prop="checkName">
        <el-cascader
          clearable
          style="width: 100%"
          v-model="ruleForm.checkName"
          :options="folder"
          :props="{
            value: 'id',
            label: 'name',
            children: 'children',
            checkStrictly: true,
          }"
          @change="handleChange"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="文件夹名称：" prop="folderName">
        <el-input v-model="ruleForm.folderName" style="width: 100%" maxlength="20" show-word-limit></el-input>
      </el-form-item>
      <!-- <el-form-item class="opeartion1" style="height: 60px">
        <el-button @click="handleCancel('ruleForm')" style="padding: 0px 20px"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="handleOk('ruleForm')"
          style="padding: 0px 20px"
          >确定</el-button
        >
      </el-form-item> -->
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel('ruleForm')">取 消</el-button>
      <el-button type="primary" @click="handleOk('ruleForm')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { createFolderFetch } from "../../api/material";
export default {
  props: {
    folder: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      ruleForm: {
        checkName: [],
        folderName: "",
      },

      rules: {
        checkName: [
          {
            type: "array",
            required: true,
            message: "请选择路径",
            trigger: "change",
          },
        ],
        folderName: [
          { required: true, message: "请填写文件夹名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    handleClose() {
      // this.$confirm("确认关闭？")
      //   .then((_) => {
      //     done();
      //   })
      //   .catch((_) => {});
      this.visible = false;
    },
    showModal(node) {
      if (node) {
        let dataArr = [node.data.id];
        let pNode = node.parent;
        while (pNode && !Array.isArray(pNode.data)) {
          dataArr.unshift(pNode.data.id);
          pNode = pNode.parent;
        }
        this.ruleForm.checkName = dataArr;
      } else {
        this.ruleForm.checkName = [];
      }
      this.visible = true;
    },
    handleChange(e) {
      console.log(e);
    },
    handleOk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          createFolderFetch({
            nowFolderId: this.ruleForm.checkName[this.ruleForm.checkName.length - 1],
            newFolderName: this.ruleForm.folderName,
          }).then((res) => {
            if (res.code == "0000") {
              this.$message({
                message: "新建成功",
                type: "success",
              });
              this.visible = false;
              this.$refs[formName].resetFields();
              this.$emit("getFolder");
            }
          });
        } else {
          return false;
        }
      });
    },
    handleCancel(formName) {
      this.$refs[formName].resetFields();
      this.visible = false;
    },
  },
};
</script>

<style lang="less">
.opeartion1 .el-form-item__content {
  margin-left: 342px !important;
  margin-top: 22px;
}
.ruleForm {
  .el-form-item:first-child {
    height: 56px;
  }
  .el-form-item {
    margin-bottom: 0px !important;
  }
  .el-form-item__label {
    padding: 0 !important;
  }
}
</style>
